export const SUBTITLE_FONT_FAMILY =
  "'Noto Sans JP', 'Inter', -apple-system, sans-serif"
export const SUBTITLE_FONT_WEIGHT = 700
export const SUBTITLE_TEXT_SHADOW = '#000000 0px 0px 7px'
export const SUBTITLE_LINE_HEIGHT = 1.5
export const SUBTITLE_COLOR = '#ffffff'

const MIN_SIZE = 16
const MIN_SIZE_SMALL = 14
const MAX_SIZE = 56
const DIVISOR = 40
const FULLSCREEN_MULTIPLIER = 1.1

export const TIER_MULTIPLIERS = {
  small: 0.8,
  medium: 1.0,
  large: 1.25,
} as const

export type SizeTier = keyof typeof TIER_MULTIPLIERS

export const calcSubtitleFontSize = (
  videoWidth: number,
  isFullscreen: boolean,
  tier: SizeTier = 'medium',
): number => {
  const base = videoWidth / DIVISOR
  const clamped = Math.min(Math.max(base, MIN_SIZE), MAX_SIZE)
  const tiered = clamped * TIER_MULTIPLIERS[tier]
  const floor = tier === 'small' ? MIN_SIZE_SMALL : MIN_SIZE
  const result = Math.max(tiered, floor)
  return isFullscreen ? result * FULLSCREEN_MULTIPLIER : result
}
